import { View, Text, styled } from 'tamagui'
import { typingUsers, users } from '@/mocks'

const Container = styled(View, {
  height: 20,
  paddingHorizontal: 4,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 4,
})

const TypingDots = styled(View, {
  flexDirection: 'row',
  gap: 2,
  alignItems: 'center',
})

const Dot = styled(View, {
  width: 4,
  height: 4,
  borderRadius: '$borderRadiusSm',
  backgroundColor: '$sidebarMuted',
})

const TypingText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 12,
  color: '$sidebarMuted',
})

interface TypingIndicatorProps {
  channelId: string
}

export function TypingIndicator({ channelId }: TypingIndicatorProps) {
  const typing = typingUsers[channelId] || []

  if (typing.length === 0) return <View height={20} />

  const names = typing.map(id => users[id]?.displayName || 'Someone')
  const text = names.length === 1
    ? `${names[0]} is typing`
    : names.length === 2
    ? `${names[0]} and ${names[1]} are typing`
    : 'Several people are typing'

  return (
    <Container>
      <TypingDots>
        <Dot
          // @ts-expect-error -- web animation
          style={{ animation: 'typingDot 1.4s ease-in-out 0s infinite' }}
        />
        <Dot
          // @ts-expect-error -- web animation
          style={{ animation: 'typingDot 1.4s ease-in-out 0.2s infinite' }}
        />
        <Dot
          // @ts-expect-error -- web animation
          style={{ animation: 'typingDot 1.4s ease-in-out 0.4s infinite' }}
        />
      </TypingDots>
      <TypingText>{text}...</TypingText>
    </Container>
  )
}
